import React from "react";
import CustomModal from "./CustomModal";
import { useSelector, useDispatch } from "react-redux";
import { closeModal } from "../redux/modalSlice";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const UserAlreadyExistsModal = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isModalOpen = useSelector((state) => state?.modal?.isOpen);
  const modalText = useSelector((state) => state?.modal?.text);

  const handleBackToLogin = () => {
    dispatch(closeModal());
    navigate("/");
  };
  return (
    <CustomModal
      className="custom_modal"
      show={isModalOpen}
      handleClose={() => dispatch(closeModal())}
    >
      <h5 className="mb-3 mb-md-5 text-center">{modalText}</h5>
      <Button
        className="default-button primary-btn rounded-pill w-75 d-block text-center mb-3 mx-auto"
        onClick={handleBackToLogin}
      >
        Back To Login
      </Button>
    </CustomModal>
  );
};

export default UserAlreadyExistsModal;
